import { useState, Fragment } from "react";
import { ChartBarIcon, PrinterIcon, Cog6ToothIcon, CalendarIcon, PhotoIcon,
  ClipboardDocumentListIcon, MagnifyingGlassIcon, StarIcon, CurrencyDollarIcon,
  WrenchIcon, GlobeAltIcon, ArrowDownOnSquareIcon, Cog8ToothIcon } from "@heroicons/react/24/outline";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { Divider } from "../components/UI/divider";

function TileButton({ name, route, Icon }) {
  const navigate = useNavigate();

  return (<div className="col-span-2 p-4 mx-6">
    <button className="place-items-center py-6 w-full bg-orange-700 p-4 text-white rounded-[0.5rem]" onClick={() => navigate(route)}>
      {Icon
        ? <div><Icon className="h-12 w-12 cursor-pointer" /></div>
        : null
      }
      <span className="text-sm">{name}</span>
    </button>
  </div>);
}

export default function ManagementMenu() {
  const TILE_GROUPS = [
    { name: "Day to Day Activities", tiles: [
        { name: "Reports", route: "/report-list", icon: ChartBarIcon },
        { name: "Print Menus", route: "/print-menus", icon: PrinterIcon },
        { name: "Tap Maintenance", route: "/taps", icon: Cog6ToothIcon },
        { name: "Events", route: "/events", icon: CalendarIcon },
        { name: "Ad Images", route: "/ad-images", icon: PhotoIcon }
      ]
    },
    { name: "Logs & History", tiles: [
        { name: "Activity Log", route: "/log", icon: ClipboardDocumentListIcon },
        { name: "Beverage Search", route: "/beverage-search", icon: MagnifyingGlassIcon },
        { name: "My Favorites", route: "/favorites", icon: StarIcon },
        { name: "Manage Sales", route: "/sales", icon: CurrencyDollarIcon }
      ]
    },
    { name: "Settings & Extras", tiles: [
        { name: "Settings", route: "/system-settings", icon: WrenchIcon },
        { name: "Web Menus", route: "/web-menus", icon: GlobeAltIcon },
        { name: "Export Menu Data", route: "/export-menu-data", icon: ArrowDownOnSquareIcon },
        { name: "Glassware Gallery", route: "/glassware", icon: Cog8ToothIcon }
      ]
    }
  ];

  return (
    <div className="ms-12">
      <h2 className="text-3xl text-orange-700 font-bold m-3">Management</h2>
      <Divider className="my-6" />
      <div className="mx-6">
      {_.map(TILE_GROUPS, tg => (
        <Fragment>
          <h2 className="font-bold text-xl">{tg.name}</h2>
          <Divider className="my-1" />
          <div className="grid md:grid-cols-12 grid-cols-3 gap-3 mb-4">
            {_.map(tg.tiles, t => (<TileButton name={t.name} route={t.route} Icon={t.icon} />))}
          </div>
        </Fragment>))}
      </div>
    </div>
  );
}